import React, { useMemo } from "react";
import Style from "./index.module.scss";
import { LabelAndValue } from "../../../../service/evaluate";
import { Table } from "antd";
import { ColumnProps } from "antd/es/table";
interface Props {
    data: LabelAndValue[];
}
const Index = ({ data }: Props) => {
    const filterData = useMemo(() => {
        return data.map(item => {
            if (!item.value) {
                item.value = "无";
            }
            return item;
        });
    }, [data]);
    const columns: ColumnProps<LabelAndValue>[] = [
        {
            title: "序号",
            width: 70,
            dataIndex: "label"
        },
        {
            title: "建议内容",
            dataIndex: "value",
            // ellipsis: true,
            render(text) {
                return <p className={Style.infos}>{text}</p>;
            }
        }
    ];

    return (
        <div className={Style.root}>
            <Table
                dataSource={filterData}
                columns={columns}
                rowKey="label"
                pagination={false}
            />
        </div>
    );
};

export default Index;
